module.exports = __webpack_public_path__ + "europa-5_front.jpg?c22f7e76c47f92a4361d1ed14ea66e39";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-5_front.jpg
// module id = 387
// module chunks = 0